import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Auth from '@aws-amplify/auth';
import axios from 'axios';
import { FormControlLabel, Checkbox } from '@material-ui/core';

// app
import { Auth as AuthEntity, Session, Signup } from '../../../entities/auth';
import { addAuth, addSession, updateSession, clearSignup } from '../../../store/action-creators';
import { colors } from '../../../config/styles';
import UtilsService from '../../../services/utils';
// containers
import AuthContainer from '../containers/Auth';
import RowContainer from '../containers/Row';
// components
import TextInput from '../../../components/inputs/TextInput';
import ActionButton from '../../../components/buttons/ActionButton';
// entities
import { Message, MessageTypes } from '../../../entities/site';
import { Mortgage } from '../../../entities/profile';
// services
import AuthService from '../../../services/auth';


const styles: any = {
  link: {
    color: colors.blue,
    cursor: 'pointer'
  },
  footer: {
    textAlign: 'center',
    fontSize: 12
  },
  notification: {
    padding: 5,
    textAlign: 'center',
    color: '#56D8A6',
    backgroundColor: '#BFC6D0'
  },
  item: {
    marginBottom: 10
  },
  items: {
    marginRight: 20
  },
  terms: {
    fontSize: 18
  }
}

interface ConfirmCodeProps {
  open: any;
  signup: Signup;
  auth: AuthEntity;
  session: Session;
  onClose(route?: string): void
  addAuth(auth: AuthEntity): void;
  addSession(session: Session): void;
  updateSession(session: Session): void;
  clearSignup(): void;
}

interface ConfirmCodeState {
  code: string;
  notification: string;
  message: Message;
  disabled: boolean;
  textConfirm: boolean;
}

class ConfirmCode extends Component<ConfirmCodeProps, ConfirmCodeState> {

  constructor(props: ConfirmCodeProps) {
    super(props);
    this.state = {
      code: '',
      notification: '',
      message: {
        message: '',
        messageType: MessageTypes.notification
      },
      disabled: false,
      textConfirm: false
    }
  }

  componentDidMount = () => {
    // mounted
  }

  

  handleConfirmcode = async () => {

    try {

      if (!this.state.code) {
        this.setState({ message: { message: 'Code required', messageType: MessageTypes.error } });
        return;
      }

      if (this.props.signup.canText && !this.state.textConfirm) {
        this.setState({ message: { message: 'Please acknowledge text terms before continuing', messageType: MessageTypes.error } });
        return;
      }

      if (!this.props.signup || !this.props.signup.username) {
        this.setState({ message: { message: 'Username required', messageType: MessageTypes.error } });
        return;
      }

      this.setState({ disabled: true });

      // confirm code
      const confirm = await Auth.confirmSignUp(this.props.signup.username, this.state.code, {
        // Optional. Force user confirmation irrespective of existing alias. By default set to True.
        forceAliasCreation: true
      });

      // get real token
      const signIn = await Auth.signIn(this.props.signup.username, this.props.signup.password);

      // get current session
      const authSession: any = await Auth.currentSession();

      // store user
      const userData = {
        userId: signIn.username,
        email: this.props.signup.email,
        name: this.props.signup.name,
        phone: this.props.signup.phone,
        canText: this.props.signup.canText
      };
      const newUserRes = await axios.post(`${AuthService.getApiUrls().user}/user`, userData);

      // get fresh copy of user
      const userRes = await axios.get(`${AuthService.getApiUrls().user}/user/${newUserRes.data.id}`)

      // store token
      const auth: AuthEntity = {
        id: signIn.username,
        token: authSession.accessToken.jwtToken,
        payload: authSession.accessToken.payload,
        user: userRes.data
      }
      this.props.addAuth(auth);

      // store first mortgage
      const addressParts = this.props.session.address ? this.props.session.address.address.split(',') : [];

      if (addressParts.length) {

        const mortgage: any = {
          userId: signIn.username,
          reportTitle: "null",
          address: addressParts[0],
          city: addressParts[1],
          state: addressParts[2],
          zipCode: "null",
          originalLoanBalance: 0,
          loanBalance: (this.props.session.address ? this.props.session.address.loanBalance : 0),
          interestRate: 0,
          mortgageInsurance: 0,
          escrow: 0
        };

        axios.post(`${AuthService.getApiUrls().user}/user/mortgage`, mortgage).then((res) => {

          if (!res.data.errorMessage) {
            // cleanup
            this.props.clearSignup();
            this.setState({ disabled: false });

            // set new id
            mortgage.id = res.data.id;

            // set current mortgage
            const newSession = this.props.session;
            newSession.selectedMortgage = mortgage;
            this.props.updateSession(newSession);

            // goto cashflow page
            this.props.onClose(`/estimator/cashflow/${res.data.id}`);

          } else {
            // something went wrong, send to home
            // this.props.clearSignup();
            // this.props.onClose('/');
          }

        }).catch((error) => {
          // something went wrong
          this.setState({ disabled: false });
          UtilsService.logError(AuthService.getApiUrls().core, 'ConfirmCode', 'addMortgage', error);
        });

      } else {

        // no address, send to home
        this.props.clearSignup();
        this.props.onClose('/');

      }

    } catch (error) {
      this.setState({ disabled: false });
      this.setState({ message: { message: 'Error confirming code', messageType: MessageTypes.error } });
      await UtilsService.logError(AuthService.getApiUrls().core, 'ConfirmCode', 'handleConfirmcode', error);
    }

  }

  handleResendCode = () => {

    if (!this.props.signup || !this.props.signup.username) {
      this.setState({ message: { message: 'Username required', messageType: MessageTypes.error } });
      return;
    }

    Auth.resendSignUp(this.props.signup.username).then(() => {
      this.setState({ message: { message: 'Confirm code has been resent.', messageType: MessageTypes.notification } });
    }).catch(e => {
      this.setState({ message: { message: 'Error resending code', messageType: MessageTypes.error } });
    });

  }

  handleLogin = () => {
    // close and open login
    this.props.onClose('login');
  }

  onCodeChange = (event: any) => {
    this.setState({ code: event.target.value });
  }

  onCanTextChange = (value: boolean) => {
    this.setState({ textConfirm: value });
  }

  render() {
    return (
      <AuthContainer
        open={this.props.open} title="Confirm Code"
        onClose={this.props.onClose}
        message={this.state.message}
      >
        {this.state.notification !== '' &&
          <div style={styles.notification}>{this.state.notification}</div>
        }
        <RowContainer>Please check your email and enter confirm code.</RowContainer>
        <RowContainer>
          <TextInput
            type="number"
            placeholder=""
            result={this.state.code}
            onChange={this.onCodeChange}
          />
        </RowContainer>
        {(this.props.signup && this.props.signup.canText) &&
          <RowContainer>
            <div style={styles.terms}>Terms of Participation</div>
            <ol style={styles.items}>
              <li style={styles.item}>
                1. If you choose to participate in this program we will use the personal information you provide only to respond to your questions or process the forms to complete the requested transactions. No information is shared with other agencies unless it is required that we do so by law, such as Public Records Laws. No information gathered is used to create individual profiles. Galilaio does not collect information for commercial marketing purposes, nor do we sell your information for commercial marketing purposes to private companies.
              </li>
              <li style={styles.item}>
                As the delivery of messages are dependent on a variety of factors, most of which are beyond anyone's control, Galilaio, and its officers, officials, employees and agents, the licensor of the software, and their agents can not and will not guarantee the delivery or the timing of any delivery of any message, wholly, or in part. Any participation in this program represents acknowledgement and agreement that Galilaio, and its officers, officials, employees and agents, the licensor of the software, and their agents shall not be liable for any consequence arising from the failure of the delivery of any part of any message, or for any delay in the receipt of any message for any reason. The user holds harmless, Galilaio, and its officers, officials, employees and agents, the licensor of the software, and their agents. Furthermore, any failure of delivery or any reliance upon this messaging system cannot be employed as a defense in any enforcement action (ticket, towing, etc.) taken against you pursuant to ordinance or statute.
              </li>
              <li style={styles.item}>
                There may be a cost per message for the receipt of a message, depending on your carrier's cell phone package. Please consult your carrier to determine what those costs may be. Galilaio is not responsible for any such charges. Such charges are your personal responsibility.
              </li>
              <li style={styles.item}>
                It is your responsibility to sign-up for the service and to maintain your current information. You may choose to unsubscribe to this service at anytime. Please allow 3 business days for processing of your request.
              </li>
              <li>
                By signing up and saving your information with us you agree to the terms of participation.
              </li>
            </ol>
            <FormControlLabel
              style={{ marginLeft: 0, marginBottom: 15 }}
              control={
                <Checkbox
                  edge="start"
                  checked={this.state.textConfirm}
                  disableRipple
                  onChange={(event: any, newValue: boolean) => this.onCanTextChange(newValue)}
                />
              }
              label="I agree to the Terms of Participation"
            />
          </RowContainer>
        }
        <RowContainer>
          <ActionButton name="Confirm" onClick={this.handleConfirmcode} size="sm" fullWidth disabled={this.state.disabled} />
        </RowContainer>
        <RowContainer>
          <div style={styles.footer}>Already confirmed code? <span style={styles.link} onClick={this.handleLogin}>Login</span></div>
          <div style={styles.footer}>Resend code? <span style={styles.link} onClick={this.handleResendCode}>Resend</span></div>
        </RowContainer>
      </AuthContainer>
    )
  }

}

const mapStateToProps = (state: any) => {
  return {
    signup: state.auth.signup,
    auth: state.auth.auth,
    session: state.session.session
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ addAuth, addSession, updateSession, clearSignup }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(ConfirmCode));



// WEBPACK FOOTER //
// ./src/pages/auth/components/ConfirmCode.tsx